import './timeline.scss';

class Timeline {
    constructor (element) {
        this.$entry = element;
        this.entryObserver = null;
        this.$indicator = this.$entry.querySelector('[data-timeline-indicator]');
        this.$year = this.$entry.querySelector('[data-timeline-year]');
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    setEvents () {
        window.eventScroller.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        const pos = this.$entry.getBoundingClientRect().top - window.innerHeight;
        const start = (100 / window.innerHeight) * ((pos) * (-1));

        if (pos < 0 && pos > ((window.innerHeight) * (-1))) {
            if (start >= 10) {
                if (start < 45) {
                    this.$indicator.style.transform = 'scaleY(0.45)';
                    this.$year.style.transform = 'scale(0.45)';
                } else {
                    this.$indicator.style.transform = 'scaleY(' + start + '%)';
                    this.$year.style.transform = 'scale(' + start + '%)';
                }
            }
        } else {
            if (pos < (window.innerHeight * (-1))) {
                this.$indicator.style.transform = 'scaleY(1)';
                this.$year.style.transform = 'scale(1)';
            }
        }
    }
}

export { Timeline };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $timeline = $context.querySelector('[data-timeline="root"]');

        if ($timeline) {
            const $entrys = $timeline.querySelectorAll('[data-timeline-entry]');

            if ($entrys.length > 0) {
                $entrys.forEach(($entry) => {
                    const entry = new Timeline($entry);
                    entry.initialize();
                });
            }
        }
    }
});
